
import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import "./ConformitySection.css";

const manufacturers = [
  "LONGi",
  "JA Solar",
  "Trina Solar",
  "Jinko Solar",
  "Canadian Solar",
  "AIKO",
  "Astronergy",
  "First Solar",
  "Risen",
  "Runergy",
  "GCL",
  "Suntech",
  "Seraphim",
  "CSun",
  "EVVO",
  "ReneSola",
  "URECO",
  "Znshine",
];

export default function ConformitySection() {
  return (
    <Box component="section" className="conformity-section">
      <Box className="conformity-heading">
        <Typography
          component="h2"
          variant="h4"
          className="conformity-title"
        >
          Доверие от водещи производители на соларни панели
        </Typography>

        <Typography className="conformity-intro">
          Продуктовата гама на ChemiTek включва решения с декларации
          за съответствие от водещи производители на фотоволтаични модули.
        </Typography>
      </Box>

      <Box className="conformity-logos">
        {manufacturers.map((manufacturer) => (
          <Box
            key={manufacturer}
            className="conformity-logo"
            aria-label={manufacturer}
          >
            {manufacturer}
          </Box>
        ))}
      </Box>

      <Typography className="conformity-note">
        Наличието на декларация зависи от конкретния препарат.
        Свържете се с нас, за да проверим документацията за вашите панели.
      </Typography>

      <Box className="conformity-action">
        <Button
          component={NavLink}
          to="/oferta-na-preparati-za-solarni-paneli"
          variant="contained"
          className="conformity-button"
        >
          Поискай документация
        </Button>
      </Box>
    </Box>
  );
}
